import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import McOverview from '../views/mc/McOverview.vue'
import McInfo from '../views/mc/McInfo.vue'
import McUserOverview from '../views/mc/McUserOverview.vue'
import McStaffOverview from '../views/mc/McStaffOverview.vue'

import DiscordOverview from '../views/discord/DiscordOverview.vue'
import DiscordInfo from '../views/discord/DiscordInfo.vue'
import DiscordUserOverview from '../views/discord/DiscordUserOverview.vue'
import DiscordStaffOverview from '../views/discord/DiscordStaffOverview.vue'

import NotFound from '../views/404.vue'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: Home
    },
    {
        path: '/bans/:page',
        redirect: '/mc/bans/:page',
    },
    {
        path: '/bans',
        redirect: '/mc/bans/1',
    },
    {
        path: '/mutes/:page',
        redirect: '/mc/mutes/:page',
    },
    {
        path: '/mutes',
        redirect: '/mc/mutes/1',
    },
    {
        path: '/kicks/:page',
        redirect: '/mc/kicks/:page',
    },
    {
        path: '/kicks',
        redirect: '/mc/kicks/1',
    },
    {
        path: '/mc/bans/:page',
        name: 'mc_bans',
        component: McOverview,
    },
    {
        path: '/mc/mutes/:page',
        name: 'mc_mutes',
        component: McOverview
    },
    {
        path: '/mc/kicks/:page',
        name: 'mc_kicks',
        component: McOverview
    },
    {
        path: '/mc/voicemutes/:page',
        name: 'mc_voicemutes',
        component: McOverview
    },
    {
        path: '/mc/names/:page',
        name: 'mc_names',
        component: McOverview
    },
    {
        path: '/mc/ban/:id',
        name: 'mc_ban',
        component: McInfo
    },
    {
        path: '/mc/kick/:id',
        name: 'mc_kick',
        component: McInfo
    },
    {
        path: '/mc/mute/:id',
        name: 'mc_mute',
        component: McInfo
    },
    {
        path: '/mc/name/:id',
        name: 'mc_name',
        component: McInfo
    },
    {
        path: '/mc/voicemute/:id',
        name: 'mc_voicemute',
        component: McInfo
    },
    {
        path: '/mc/user/:username/:page',
        name: 'mc_user',
        component: McUserOverview,
        props: true,
    },
    {
        path: '/mc/staff/:username/:page',
        name: 'mc_staff',
        component: McStaffOverview,
        props: true,
    },
    {
        path: '/discord/bans/:page',
        name: 'discord_bans',
        component: DiscordOverview,
    },
    {
        path: '/discord/mutes/:page',
        name: 'discord_mutes',
        component: DiscordOverview
    },
    {
        path: '/discord/kicks/:page',
        name: 'discord_kicks',
        component: DiscordOverview
    },
    {
        path: '/discord/kick/:id',
        name: 'discord_kick',
        component: DiscordInfo
    },
    {
        path: '/discord/mute/:id',
        name: 'discord_mute',
        component: DiscordInfo
    },
    {
        path: '/discord/ban/:id',
        name: 'discord_ban',
        component: DiscordInfo
    },
    {
        path: '/discord/user/:id/:page',
        name: 'discord_user',
        component: DiscordUserOverview
    },
    {
        path: '/discord/staff/:id/:page',
        name: 'discord_staff',
        component: DiscordStaffOverview
    },
    {
        path: '/404',
        name: 'notfound',
        component: NotFound
    },
    {
        path: '*',
        redirect: '/404'
    }
];

// https://router.vuejs.org/guide/essentials/dynamic-matching.html#reacting-to-params-changes

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
